import { ReactNode, useMemo } from 'react';

import { Tooltip } from '@/design-system';
import { ExperimentViewOverridesSchema } from '@/types/schema';

import { calculateMaxFractionDigits } from './utils';

export const AggregatedStatHeader = ({
  stat,
  type,
  tooltip,
  columnOverride,
}: {
  stat?: number;
  type: string;
  tooltip?: ReactNode;
  columnOverride?: ExperimentViewOverridesSchema['column_overrides'][number];
}) => {
  const minimumFractionDigits = columnOverride?.precision ?? 2;
  const maximumFractionDigits =
    columnOverride?.precision ?? calculateMaxFractionDigits(stat);
  const formatter = useMemo(() => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits,
      maximumFractionDigits,
    });
  }, [maximumFractionDigits, minimumFractionDigits]);

  if (stat == null) return null;

  const displayStat = !Number.isNaN(stat) ? formatter.format(stat) : '--'; // should we just return null?
  return (
    <Tooltip title={tooltip}>
      <div className="flex items-baseline gap-1">
        <span className="text-[16px]">{displayStat}</span>
        <span className="text-[10px] text-tertiary">{type}</span>
      </div>
    </Tooltip>
  );
};
